/**
 *
 * @param fieldConfig {FormFieldConfig}
 * @param form {FormConfig}
 * @param context
 * @param entitiesList {EntitiesList}
 */
import FormsActions from "@/components/forms/FormsActions";
import SelectFilterSpec from "@/server/com/silkplm/engine/forms/schema/definition/filters/SelectFilterSpec";
import CheckBoxFilterSpec from "@/server/com/silkplm/engine/forms/schema/definition/filters/CheckBoxFilterSpec";

/**
 *
 * @param fieldConfig {CheckboxFormFieldConfig}
 * @param form
 * @param context
 * @param entitiesList
 * @param filterSpec
 * @return {CheckBoxFilterSpec}
 */
export async function checkboxFilter(fieldConfig, form, context, entitiesList, filterSpec) {
    let filterVal = await DialogManager.checkBox("Add filter", fieldConfig.fieldLabel, filterSpec)
    if(filterVal === null){
        return null;
    }

    let spec = new CheckBoxFilterSpec();
    spec.expectedValue = filterVal;

    return spec;
}